import React from 'react'
import {LoginModalOverlay} from 'common/styleguide/LoginModalOverlay'
import {Button} from 'common/Button'

export class SigninButton extends React.PureComponent {
  static defaultProps = {
    buttonText: 'Sign In',
    noStyle: false
  }
  constructor (props) {
    super(props)
    this.state = {
      showModal: false
    }
  }

  showModal = () => this.setState({showModal: true})

  hideModal = () => this.setState({showModal: false})

  render () {
    const {showModal} = this.state
    const {className, id, type, buttonText, redirectTo, noStyle, block} = this.props
    return (
      <div id={id} style={{display: block ? 'block' : 'inline-block'}}>
        {noStyle
          ? <a className={className} onClick={this.showModal}>{buttonText}</a>
          : <Button type={type || 'default'} className={className} onClick={this.showModal}>{buttonText}</Button>}
        {showModal && <LoginModalOverlay onRequestClose={this.hideModal} redirectTo={redirectTo} />}
      </div>
    )
  }
}
